import React from 'react';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { Typography, Button } from '@mui/material';
// import { useStore } from 'src/stores';
import combine1 from 'src/img/combine1.png';
import combine2 from 'src/img/combine2.png';
import { Icon } from '@livable/saas-react-components';
export const CombineMultipleUtilitiesModalForm = observer(_ref => {
  let handleModalClose = _ref.handleModalClose;
  const modalFooterClasses = useModalFooterStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.urjanet_api')), /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.itemWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: combine2,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.itemWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: combine1,
    alt: ""
  }))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '208-CombineMultipleUtilitiesModalForm'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "text",
    onClick: () => {},
    'custom-attribute': '207-CombineMultipleUtilitiesModalForm'
  }, t('add_new_property_flow.create_new_template'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    onClick: () => {},
    'custom-attribute': '209-CombineMultipleUtilitiesModalForm'
  }, t('add_new_property_flow.combine_existing_ones')))))));
});